class CoverageManager {
  constructor(data) {
    this.data = data;
    this.total = this.getTotal();
    this.donutGraphData = this.getDonutGraphData();
  }

  apiResponse = () => {
    return this.data;
  };

  getTotal = () => {
    let total = 0;
    this.data.forEach(([_, num]) => {
      total += num;
    });

    return total;
  };

  getColorAndTooltip = (key) => {
    switch (key) {
      case 'Morning':
        return ['#5A8BED', '12am to 12pm'];
      case 'Afternoon':
        return ['#3FCB7F', '12pm to 4pm'];
      case 'Evening':
        return ['#FFB500', '4pm to 8pm'];
      case 'Night':
        return ['#916C00', '8pm to 12am'];
      default:
        return '';
    }
  };

  getDonutGraphData = () => {
    let n = this.data.length,
      total_sum = 0;
    return this.data.map(([key, value], index) => {
      let per = Math.round((value / this.total) * 100);

      if (index === n - 1 && total_sum + per < 100) per += 100 - (total_sum + per);
      else if (total_sum + per > 100) per -= total_sum + per - 100;
      else total_sum += per;

      const colorAndTooltip = this.getColorAndTooltip(key);
      return {
        text: key,
        number: value,
        percentage: per,
        color: colorAndTooltip[0],
        tooltip: colorAndTooltip[1],
      };
    });
  };
}

export default CoverageManager;
